import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-analyticssmslogsdata',
  templateUrl: './analyticssmslogsdata.component.html',
  styleUrls: ['./analyticssmslogsdata.component.css']
})
export class AnalyticssmslogsdataComponent implements OnInit {
  @Input('details') details: any;
  saving = false;
  @Output() saveAnalytics = new EventEmitter();
  @Output() modifyAnalytics = new EventEmitter();

  constructor(private _location: Location) {
  }

  ngOnInit() {
  }
  saveSMSAnalyticsResult() {
    this.saveAnalytics.emit();
  }
  modifyAnalyticsResult() {
    this.modifyAnalytics.emit();
  }
  goBack() {
    this._location.back();
  }
}
